module.exports = __webpack_public_path__ + "inistate-logo-with-text-transparent.svg?13d37acb315027303fbb7eefbca2bce9";